import { createState, useState } from '@hookstate/core';

const initialState = {
    parti: "",
    search: "",
    status: "",
    type: ""
};

const searchObjState = createState(initialState);

export const setSearchObjState = (props) => {
    //console.log("props",props);  
    if (props) {
        searchObjState.set({
            ...initialState,
            parti: props.parti,
            search: props.search,
            status: props.status,
            type: props.type
        });
    }
    return;
};
export const useSearchObjState = () => {
    return useState(searchObjState);
};
export const exitTheme = () => {
    // Helper.removeStorage('eventInfo');
    // Helper.removeStorage('eventModuleConfig');
    searchObjState.set(initialState);
};
